<template>
  <div style="padding:14px 10px">
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.name" placeholder="Name" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.country" clearable placeholder="Country"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
        </el-option>
      </el-select>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
        <el-button size="small" type="danger" icon="el-icon-delete" :disabled="selectedRows.length === 0" @click="batchDelete">
          Batch Delete<span v-if="selectedRows.length > 0"> ({{ selectedRows.length }})</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading"
      element-loading-text="Loading..." style="width: 1382px" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="id" label="ID" width="80" align="center">
      </el-table-column>
      <el-table-column prop="name" label="Name" width="100">
      </el-table-column>
      <el-table-column prop="pwd" label="Password" width="100">
      </el-table-column>
      <el-table-column prop="country" label="Country" width="100">
      </el-table-column>
      <el-table-column prop="is_top" label="Status" width="90" align="center" sortable>
        <template slot-scope="scope">
          <el-link type="info" :underline="false" v-if="scope.row.state==1">using</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==2">disabled</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="save_time" align="center" label="Save time" width="160">
        <template slot-scope="scope">
          <div>{{scope.row.save_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="next_active_time" align="center" label="上一次活动时间" width="160">
        <template slot-scope="scope">
          <div>{{scope.row.next_active_time|timestampToTime}}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="last_active_time" align="center" label="Status" width="100">
        <template slot-scope="scope">
          <el-link type="success" :underline="false" v-if="scope.row.socket_id>0">online</el-link>
          <el-link type="danger" :underline="false" v-else>offline</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="card_list" label="SIM Card">
        <template slot-scope="scope">
          <div v-for="(item,i) in scope.row.card_list" :key="i"
            @click="deleteCard(item.id,item.number,item.business_name)">
            <el-link type="warning" icon="el-icon-edit" :underline="false"><span
                style="color:#000000">{{item.number}}</span><span
                v-if="item.business_name">【{{item.business_name}}】</span>
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="save_time" align="center" label="Withdraw Business" width="160">
        <template slot-scope="scope">
          <div @click="setTrans(scope.row)">
            <el-link type="success" icon="el-icon-edit" :underline="false" v-if="scope.row.business_name">
              {{scope.row.business_name}}</el-link>
            <el-link type="warning" icon="el-icon-edit" :underline="false" v-else>Set up</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="280">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="warning" @click="getAllMessage(scope.row.id)">Get All</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="Name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Password" prop="name">
          <el-input size="small" v-model="editForm.pwd" auto-complete="off" placeholder="Password" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Country" prop="country">
          <el-select size="small" v-model="editForm.country" clearable placeholder="Please select country">
            <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Status" prop="url">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1">using</el-radio>
            <el-radio :label="2">disabled</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="transferVisible" @click='closeDialog("transfer")' width="40%">
      <el-descriptions title="Withdraw Business" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item label="Name">{{transfer_info.name}}</el-descriptions-item>
        <el-descriptions-item label="Country">{{transfer_info.country}}</el-descriptions-item>
        <el-descriptions-item label="Withdraw Business" span="1">
          <el-select size="small" v-model="selected_business_name" clearable placeholder="Please select business">
            <el-option v-for="item in app_transfer_business" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="transferBusinessSucc(selected_business_name)">Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    smsAppList,
    smsAppSave,
    smsAppDel,
    smsAppGetSocketId,
    appCardDel,
    countryList,
    AppTransferBusiness,
    SetAppTransferBusiness
  } from '../../api/apiFun'
  import {
    timestampToTime,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'

  let that = ""
  export default {
    data() {
      return {
        countryList: [],
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        transferVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        params: {
          page: 1,
          limit: 20,
          name: '',
          country: '',
        },
        listData: [], //User数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 20
        },
        editForm: {
          id: '',
          name: '',
          pwd: '',
          country: '',
          state: '',
        },
        // rules 表单验证
        rules: {
          name: [{
            required: true,
            message: 'Please enter name',
            trigger: 'blur'
          }],
          pwd: [{
            required: true,
            message: 'Please enter password',
            trigger: 'blur'
          }],
          country: [{
            required: true,
            message: 'Please select country',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: 'Please select status',
            trigger: 'blur'
          }],
        },
        socket: null,
        selectedRows: [],
        transfer_info: {},
        app_transfer_business: [],
        selected_business_name: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
    },
    created() {
      that = this
      this.getCountryList()
      this.getdata(this.params)
    },
    methods: {
      handleSelectionChange(selection) {
        this.selectedRows = selection
      },
      batchDelete() {
        if (this.selectedRows.length === 0) return
        this.$confirm(`Are you sure you want to delete the selected ${this.selectedRows.length} user(s)?`, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          const deletePromises = this.selectedRows.map(row =>
            smsAppDel({ id: row.id, name: row.name })
          )
          this.loading = true
          Promise.all(deletePromises).then(results => {
            this.loading = false
            const allSuccess = results.every(res => res.code == 200)
            if (allSuccess) {
              this.$message({ type: 'success', message: `Successfully deleted ${this.selectedRows.length} user(s)!` })
            } else {
              this.$message({ type: 'warning', message: 'Some deletions may have failed, please refresh to check.' })
            }
            this.selectedRows = []
            this.getdata(this.params)
          }).catch(err => {
            this.loading = false
            this.$message.error('Batch deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({ type: 'info', message: 'Batch delete cancelled' })
        })
      },
      transferBusinessSucc(business_name) {
        SetAppTransferBusiness({
          business_name: business_name,
          id: this.transfer_info.id
        }).then(res => {
          if (res.code == 200) {
            this.transferVisible = false
            this.getdata(this.params)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.$message.error('The specified payment business failed, please try again later!')
        })
      },
      setTrans(row) {
        this.transfer_info = row
        this.AppTransferBusiness(row.country)
      },
      AppTransferBusiness(country) {
        AppTransferBusiness({
          country
        }).then(res => {
          if (res.code == 200) {
            this.app_transfer_business = res.datas
            this.transferVisible = true
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.$message.error('Failed to get business, please try again later!')
        })
      },
      deleteCard(id, number, business_name) {
        if (!business_name) {
          this.$message.error('No business use the card!')
          return
        }
        this.$confirm('Confirm to stop the business' + number + '?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          appCardDel({
            id
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success！'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {
          
        })
      },
      getAllMessage(id) {
        smsAppGetSocketId({
          id
        }).then(res => {
          if (!res.datas) {
            this.$message.error('The User has been offline and cannot be retrieved')
          }
          this.global.send(JSON.stringify({
            type: 'admin_send',
            socket_id: res.datas
          }))
        }).catch(err => {
          this.$message.error('Failed to get SMS, please try again later!')
        })
      },
      deleteUser(index, row) {
        this.$confirm('Are you sure you want to delete?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          smsAppDel({
            id: row.id,
            name: row.name,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'successfully deleted!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Undelete'
          })
        })
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.name = row.name
          this.editForm.pwd = row.pwd
          this.editForm.country = row.country
          this.editForm.state = row.state
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.name = ''
          this.editForm.pwd = ''
          this.editForm.country = ''
          this.editForm.state = 1
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            smsAppSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Saved successfully'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            return false
          }
        })
      },
      // 获取APP User
      getCountryList() {
        countryList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.countryList = res.datas
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      getdata(parameter) {
        if (parameter.trans_time == null) {
          parameter.trans_time = ''
        }
        if (parameter.save_time == null) {
          parameter.save_time = ''
        }
        this.loading = true
        smsAppList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get app user, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      closeDialog(type) {
        if (type == 'transfer') {
          this.transferVisible = false
        }
        if (type == 'edit') {
          this.editFormVisible = false
        }
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>


// WEBPACK FOOTER //
// src/views/sms/sms_app.vue